import React from 'react';
import { Loader2 } from 'lucide-react';
import { useLanguageStore } from '../../store/languageStore';
import translations from '../../translations';

interface TaskConfirmationDialogProps {
  taskDescription: string;
  type: 'start' | 'end'; // Add the missing type prop
  onConfirm: () => void;
  onCancel: () => void;
  loading: boolean;
}

export function TaskConfirmationDialog({
  taskDescription,
  type, // Add type to destructured props
  onConfirm,
  onCancel,
  loading,
}: TaskConfirmationDialogProps) {
  const { language } = useLanguageStore();
  const t = translations[language].timeTracker;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[60]">
      <div className="bg-light-card dark:bg-dark-card rounded-lg p-6 max-w-sm w-full">
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
          {type === 'start'
            ? t.confirmations.task.startTitle
            : t.confirmations.task.endTitle}
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-2">
          {type === 'start'
            ? t.confirmations.task.startMessage
            : t.confirmations.task.endMessage}
        </p>
        <div className="flex justify-end gap-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
            disabled={loading}
          >
            {t.buttons.cancel}
          </button>
          <button onClick={onConfirm} disabled={loading} className="btn-danger">
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin" />
                {t.buttons.processing}
              </>
            ) : type === 'start' ? (
              t.confirmations.task.startTitle
            ) : (
              t.confirmations.task.endTitle
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
